import { settingsContainer } from "../../di/container";
import {
  SettingsFormOperations,
  UseSettingsFormReturn,
  useSettingsForm,
} from "./useSettingsForm";

export type UseGstSettingsReturn = UseSettingsFormReturn;

/** Module scope, for the same reason as in useCompanySettings. */
const OPERATIONS: SettingsFormOperations = {
  load: (signal) => settingsContainer.getGstSettings().execute(signal),
  save: (original, edited) => settingsContainer.updateGstSettings().execute(original, edited),
  subject: "GST settings",
};

/** Owns the GST panel form: loading, editing, saving. */
export const useGstSettings = (): UseGstSettingsReturn => useSettingsForm(OPERATIONS);
